<template>
  <span>
    <el-button type="text" :disabled="contract.status !== 'ACTIVE'" @click="open">生成订单</el-button>
    <el-dialog title="合同生成销售订单" :visible.sync="visible" width="620px" append-to-body>
      <el-alert title="选取同客户及商机的已通过报价，合同金额应与报价一致。订单保存报价产品与价格快照；同一合同只生成一张订单。" type="info" :closable="false" />
      <el-form label-width="100px" style="margin-top:20px" v-loading="loading"><el-form-item label="合同">{{ contract.title || contract.contractNo }} · ¥ {{ contract.amount }}</el-form-item><el-form-item label="来源报价" required><el-select v-model="quoteId" style="width:100%" placeholder="选择已通过的报价"><el-option v-for="q in quotes" :key="q.id" :value="q.id" :label="q.quoteNo + ' · ¥ ' + q.amount" /></el-select></el-form-item></el-form>
      <el-empty v-if="!loading && !quotes.length" description="暂无匹配的已通过报价，请先完成报价与审批" />
      <div slot="footer"><el-button @click="visible=false">取消</el-button><el-button type="primary" :loading="saving" :disabled="!quoteId" @click="generate">确认生成</el-button></div>
    </el-dialog>
  </span>
</template>
<script>
import { crm } from '../api/crm'
export default {
  name:'CrmOrderGenerate',props:{contract:{type:Object,required:true}},
  data(){return {visible:false,loading:false,saving:false,quotes:[],quoteId:null}},
  methods:{
    async open(){this.visible=true;this.quoteId=null;this.loading=true;try{const res=await crm.quotes();this.quotes=(res.data || []).filter(q=>q.status==='APPROVED' && q.customerId===this.contract.customerId && (!this.contract.dealId || q.dealId===this.contract.dealId))}finally{this.loading=false}},
    async generate(){this.saving=true;try{const res=await crm.generateOrder(this.contract.id,this.quoteId);this.visible=false;this.$message.success('订单已生成：'+res.data.orderNo);this.$emit('generated',res.data);this.$router.push({path:'/crm/order',query:{orderId:res.data.id}})}finally{this.saving=false}}
  }
}
</script>
